import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";
import { MyAssignmentPanel } from "./MyAssignmentWidget";
import { todayStr } from "./assignmentConstants";

// Shown once per login session (not on every page nav) so a staff member immediately
// sees which pod/area they're covering today — or, under self-serve mode, is prompted
// to set it themselves.
export function LoginAssignmentPopup() {
    const { user } = useAuth();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const uid = user?.id || user?._id;
        if (!uid || !["institution", "institution_admin"].includes(user?.role)) return;
        const key = `bp_assignment_popup_${uid}_${todayStr()}`;
        if (sessionStorage.getItem(key)) return;
        sessionStorage.setItem(key, "1");
        setOpen(true);
    }, [user]);

    if (!user) return null;

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent data-testid="login-assignment-popup" className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Your assignment today</DialogTitle>
                </DialogHeader>
                <MyAssignmentPanel compact />
                <Button data-testid="login-assignment-popup-close" onClick={() => setOpen(false)}>Got it</Button>
            </DialogContent>
        </Dialog>
    );
}
